import { AgenteFinanceiro } from './agente-financeiro.model';
import { BaseModel } from './base-model.model';

export class Tranche extends BaseModel {
  public numeroTranche: number;

  public dataInicioContratacao: Date;
  public dataFimContratacao: Date;
  public dataInicioProtocolo: Date;
  public dataFimProtocolo: Date;
  public dataInicioCobrancaEcg: Date;
  public dataFimCobrancaEcg: Date;

  public siglaModalidadeGarantia: string;
  public dataFimLiberacoes: Date;
  public dataFimRetificacoes: Date;
  public taxaStopLossPorteMicroEmpresa: number; //big decimal
  public taxaStopLossPortePequenaEmpresa: number; //big decimal
  public taxaStopLossPorteMediaEmpresa: number; //big decimal
  public taxaStopLossPorteGrandeEmpresa: number; //big decimal
  public percentualGarantidoEmbutidoTaxaStopLoss: boolean;
  public valorFaturamentoMinimo: number; //big decimal
  public valorFaturamentoMaximo: number; //big decimal
  public valorCreditoMinimo: number; //big decimal
  public valorLimiteTotalBeneficiario: number; //big decimal
  public quantidadeMesesPrazoMinimoCarencia: number; //integer
  public quantidadeMesesPrazoMaximoCarencia: number; //integer
  public quantidadeMesesPrazoMinimoTotal: number; //integer
  public quantidadeMesesPrazoMaximoTotal: number; //integer
  public quantidadeDiasLimiteRetificacao: number; // integer
  public indicadorAditivoHabilitado: boolean;
  public idTipoCalculoLimite: number; //long
  public idTipoCalculoLimiteAgenteFinanceiro: number;
  public indicadorLimiteEspecialHabilitado: boolean;
  public possuiTaxaStopLossUnica: boolean;
  public colunasValorLiberadoStopLoss: string[];
  public taxasStopLoss: TaxaStopLoss[];
  public fatoresRedutores: FatorRedutor[];
  public historicoValorLimiteTotalBeneficiario: LimiteContratacaoBeneficiario[];
  public historicoValorLimiteTotalOperacao: LimiteContratacaoOperacao[];
  public historicos: HistoricoTranche[];
  public prazosContratacao: PrazoContratacao[];
  public usuarioResponsavel: string;
  public quantidadeDiasLimiteAditivo: number; //integer
  public eventosDistribuicao: EventoDistribuicao[];
  public temFatorKParaCalculoEcg: boolean;
}

export class TaxaStopLoss extends BaseModel {
  public siglaPorteBeneficiario: string;
  public dataInicioValidade: Date;
	public dataFimValidade: Date;
	public taxa: number;
}

export class FatorRedutor extends BaseModel {
  public fatorRedutor: number;
	public limiteInferior: number;
	public limiteSuperior: number;
}

export class LimiteContratacaoBeneficiario {
  public dataInicioValidade: Date;
	public dataFimValidade: Date;
	public valor: number;
}

export class LimiteContratacaoOperacao {
  public dataInicioValidade: Date;
	public dataFimValidade: Date;
	public valor: number;
  public siglaPorte: string;
  public objetivoFinanciamento: string;
}

export enum SiglaPorte {
  MICROEMPREENDEDOR_INDIVIDUAL = 'MEI',
  MICRO_EMPRESA = 'ME',
  PEQUENA_EMPRESA = 'P',
  MEDIA_EMPRESA = 'M',
  GRANDE_EMPRESA = 'G',
}

export const LabelSiglaPorte = new Map<string, string>([
  [SiglaPorte.MICROEMPREENDEDOR_INDIVIDUAL, 'MEI - Microempreendedor Individual'],
  [SiglaPorte.MICRO_EMPRESA, 'ME - Micro Empresa'],
  [SiglaPorte.PEQUENA_EMPRESA, 'P - Pequena Empresa']
])

export class VigenciaFatorEcg {
  public id: number;
  public dataInicioVigencia: Date;
  public dataFimVigencia: Date;
  public ideAnterior: number;
  public fatoresEcg: FatorEcg[];
}

export class FatorReducaoEcg {
  public id: number;
  public dataInicioVigencia: Date;
  public dataFimVigencia: Date;
  public valorFatorRedutorEcg: number;
  public ideAnterior: number;
}

export class FatorEcg {
  public id: number;
  public quantidadeMesesPrazoTotalInicial: number;
  public quantidadeMesesPrazoTotalFinal: number;
  public valorFatorEcg: number;
}

export class EventoDistribuicao {
  public idEventoDistribuicaoLimiteAgenteFinanceiro: number;
  public dataEvento: Date;
  public tipoEvento: TipoEventoDistribuicao;
  public agenteFinanceiro: AgenteFinanceiro;
  public idLimiteAgenteTranche: number;
}

export class TipoEventoDistribuicao {
  public ideTipoEvento: string;
}

export class CicloDistribuicaoLimite {
  public idCicloDistribuicaoLimiteAgenteFinanceiro: number;
  public dataInicio: Date;
  public dataFim: Date;
  public numeroCiclo: number;
}

export class HistoricoTranche {

  public id: string;
  public numeroTranche: number;
  public siglaModalidadeGarantia: string;
  public dataCriacao: Date;
  public usuarioResponsavel: string;

  public dataInicioContratacao: Date;
  public dataFimContratacao: Date;
  public dataInicioProtocolo: Date;
  public dataFimProtocolo: Date;
  public dataFimLiberacoes: Date;
  public dataFimRetificacoes: Date;
  public dataInicioCobrancaEcg: Date;
  public dataFimCobrancaEcg: Date;

  public percentualGarantidoEmbutidoTaxaStopLoss: boolean;

  public valorFaturamentoMinimo: number;
  public valorFaturamentoMaximo: number;
  public valorCreditoMinimo: number;

  public valorLimiteTotalBeneficiario: number;

  public quantidadeMesesPrazoMinimoCarencia: number;
  public quantidadeMesesPrazoMaximoCarencia: number;
  public quantidadeMesesPrazoMinimoTotal: number;
  public quantidadeMesesPrazoMaximoTotal: number;
  public quantidadeDiasLimiteRetificacao: number;
  public quantidadeDiasLimiteAditivo: number;

  public indicadorAditivoHabilitado: boolean;
  public indicadorLimiteEspecialHabilitado: boolean;

  public idTipoCalculoLimite: number;
}

export class PrazoContratacao extends BaseModel
{
   dataInicioValidade: Date;
   dataFimValidade: Date;
   quantidadeMesesPrazoMaximoCarencia: number;
   quantidadeMesesPrazoMaximoTotal: number;
   quantidadeMesesPrazoMinimoCarencia: number;
   quantidadeMesesPrazoMinimoTotal: number;
}

export class PorteEmpresaClienteTrancheDTO extends BaseModel
{
   dataInicioValidade: Date;
   dataFimValidade: Date;
   faturamentoMinimo: number;
   faturamentoMaximo: number;
   porteEmpresa: string;
   dataCriacao: Date;

}



export enum TipoCalculoLimite {
  Credito = 1,
  Comprometimento = 2,
  ValorGarantido = 3,
}

export const LabelTipoCalculoLimite = new Map<number, string>([
  [TipoCalculoLimite.Credito, 'Crédito'],
  [TipoCalculoLimite.Comprometimento, 'Comprometimento'],
  [TipoCalculoLimite.ValorGarantido, 'Valor Garantido'],
])


export const TIPO_CALCULO_LIMITE = [

  {
    nome: 'Crédito',
    numero: '1'

  },
  {
    nome: 'Comprometimento',
    numero: '2'
  },
  {
    nome: 'Valor Garantido',
    numero: '3'
  }
]

export const SIGLA_PORTE_BENEFICIARIO = [
  {
    nome: 'MEI - Micro Empresa Individual',
    sigla: SiglaPorte.MICROEMPREENDEDOR_INDIVIDUAL
  },
  {
    nome: 'ME - Micro Empresa',
    sigla: SiglaPorte.MICRO_EMPRESA
  },
  {
    nome: 'P - Pequena Empresa',
    sigla: SiglaPorte.PEQUENA_EMPRESA
  },
  {
    nome: 'M - Média Empresa',
    sigla: SiglaPorte.MEDIA_EMPRESA
  },
  {
    nome: 'G - Grande Empresa',
    sigla: SiglaPorte.GRANDE_EMPRESA
  },
]
